import { render, staticRenderFns } from "./ODView.vue?vue&type=template&id=1fd00a7f"
import script from "./ODView.vue?vue&type=script&lang=js"
export * from "./ODView.vue?vue&type=script&lang=js"
import style0 from "./ODView.vue?vue&type=style&index=0&id=1fd00a7f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports